var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c(
        "v-col",
        {
          staticClass: "px-0 pt-0 grey-background",
          style: `position:fixed !important; top: 50px; z-index: 5; min-width: 860px; max-width: calc(100% - ${
            _vm.$store.state.base.isExpandNavigationDrawer ? 267 : 105
          }px); ${
            _vm.scroll > 100
              ? "box-shadow: 2px 4px 6px -6px rgba(69, 90, 100, 0.15);"
              : ""
          }`,
          attrs: { cols: "12" },
        },
        [
          _c(
            "v-tabs",
            {
              key: `${_vm.$store.state.base.isExpandNavigationDrawer}-${_vm.reset}`,
              staticClass: "pt-5",
              attrs: { optional: false },
              model: {
                value: _vm.selectedItem,
                callback: function ($$v) {
                  _vm.selectedItem = $$v
                },
                expression: "selectedItem",
              },
            },
            _vm._l(_vm.list, function (item, i) {
              return _c(
                "v-tab",
                {
                  key: `${i}-${_vm.reset}`,
                  attrs: {
                    to: item?.children?.length
                      ? null
                      : { name: item.route, params: _vm.$route.params },
                    ripple: false,
                  },
                },
                [
                  !item?.children?.length
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "ml-n1",
                            staticStyle: { "min-width": "30px" },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                contain: "",
                                src: require(`@/assets/account/${
                                  item.svg
                                }-icon${
                                  _vm.$route.name === item.route
                                    ? "-active"
                                    : _vm.$vuetify.theme.dark
                                    ? "-dark"
                                    : ""
                                }.svg`),
                                height: 14,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              item.text === "SII"
                                ? _vm.$t("generals.SII")
                                : item.text
                            ) +
                            " "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "px-1", staticStyle: { "margin-top": "60px" } },
        [_c("router-view")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }